import React from "react";
import { Card, Table, Button } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function RecentLeads() {
  const leads = [
    {
      name: "BrightWave",
      img: "/assets/img/company/company-01.svg",
      stage: "Contacted",
      date: "14 Jan 2024",
      owner: "William Parsons",
    },
    {
      name: "Stellar",
      img: "/assets/img/company/company-02.svg",
      stage: "Closed",
      date: "21 Jan 2024",
      owner: "Lucille Tomberlin",
    },
    {
      name: "Quantum",
      img: "/assets/img/company/company-03.svg",
      stage: "Lost",
      date: "20 Feb 2024",
      owner: "Frederick Johnson",
    },
    {
      name: "EcoVision",
      img: "/assets/img/company/company-04.svg",
      stage: "Not Contacted",
      date: "15 Mar 2024",
      owner: "Sarah Henry",
    },
    {
      name: "Aurora",
      img: "/assets/img/company/company-05.svg",
      stage: "Closed",
      date: "12 Apr 2024",
      owner: "Thomas Miller",
    },
  ];

  const getBadgeClass = (stage) => {
    switch (stage) {
      case "Contacted":
        return "badge-contacted";
      case "Closed":
        return "badge-closed";
      case "Lost":
        return "badge-lost";
      case "Not Contacted":
        return "badge-not-contacted";
      default:
        return "";
    }
  };

  return (
    <div className="col-xl-7 d-flex h-100 w-100">
      <Card className="flex-fill recent-leads-card  shadow-sm">
        {/* HEADER */}
        <Card.Header className="d-flex justify-content-between align-items-center card-header-custom">
          <h5 className="mb-0">Recent Leads</h5>

          {/* 🔥 Link instead of anchor */}
          <Link to="/leads">
            <Button variant="light" className="view-btn border">
              View All
            </Button>
          </Link>
        </Card.Header>

        {/* TABLE */}
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table className="mb-0 align-middle dashboard-table">
              <thead>
                <tr style={{fontSize:"14px"}}>
                  <th>Company Name</th>
                  <th>Stage</th>
                  <th>Created Date</th>
                  <th>Lead Owner</th>
                </tr>
              </thead>

              <tbody>
                {leads.map((lead, index) => (
                  <tr key={index}>
                    {/* COMPANY */}
                    <td>
                      <div className="d-flex align-items-center p-2">
                        
                        {/* 🔥 Logo Click Link */}
                        <Link
                          to="/company-details"
                          className="avatar border rounded-circle text-decoration-none"
                        >
                          <img
                            src={lead.img}
                            alt={lead.name}
                            className="img-fluid"
                          />
                        </Link>

                        <div className="ms-2">
                          <h6 className="text-dark mb-0">
                            
                            {/* 🔥 Name Click Link */}
                            <Link
                              to="/company-details"
                              className="company-link text-dark text-decoration-none"
                            >
                              {lead.name}
                            </Link>

                          </h6>
                        </div>
                      </div>
                    </td>

                    {/* STAGE */}
                    <td>
                      <span
                        className={`badge d-inline-flex align-items-center ${getBadgeClass(
                          lead.stage
                        )}`}
                      >
                        <FaCircle size={8} className="me-1" />
                        {lead.stage}
                      </span>
                    </td>

                    {/* DATE */}
                    <td style={{fontSize:"15px"}}  >{lead.date}</td>

                    {/* OWNER */}
                    <td style={{fontSize:"15px"}}  >{lead.owner}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
      <style>
          {

               `
               .recent-leads-card{border-radius:5px;
border:2px solid #e5e7eb;
               
               }
                     .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}`
          }
      </style>
    </div>
  );
}